import { useMutation, useQueryClient } from 'libs/query'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useTranslation } from 'libs/i18n'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import type { ConditionItem } from 'features/conditions/types/conditions.types'

type UseCreateConditionMutationProps = {
	onSuccess: () => void
}

export const useCreateConditionMutation = ({ onSuccess }: UseCreateConditionMutationProps) => {
	const { t } = useTranslation()

	const queryClient = useQueryClient()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: createCondition, isPending: createConditionLoading } = useMutation({
		mutationFn: (data: Pick<ConditionItem, 'name'>) => {
			return axiosPrivate.post(apiRoutes.conditions(''), data)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.conditions.all })
			useToast({ type: 'success', message: t('New condition created!') })()

			onSuccess()
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		createCondition,
		createConditionLoading
	}
}
